import Link from 'next/link';
import { ReactComponent as SvgExternal } from 'public/assets/icons/externallink.svg';

interface IViewTabProps {
  title: string
  className: string
  url?: string
  isExternal?: boolean
  onClick: () => void
}

const ViewTab = ({
  title, className, url, onClick, isExternal,
}: IViewTabProps) => {
  const showIsExternal = (!!url && url.startsWith('http')) || isExternal;
  if (url) {
    return (
      <Link
        href={url}
        target={showIsExternal ? '_blank' : undefined}
        rel="nofollow noreferrer"
        className={className}
        onClick={onClick}
      >
        {title}
        {showIsExternal && <SvgExternal />}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
    >
      {title}
      {showIsExternal && <SvgExternal width={20} />}
    </button>
  );
};

export default ViewTab;
